import { ObjectType } from '@/shared/entities/types';
import { CSSProperties } from 'react';
import TextType from 'vkit/lib/shared/components/text/types/text.type';

export interface InputClickRefInterface {
  onHandleFileSelect: Function;
}

export enum STATUS_FILE {
  PENDING = 'pending',
  UPLOADING = 'uploading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface StatusFile {
  value: STATUS_FILE;
  messageError?: string;
}

export interface FileUploadInterface {
  onChange: Function;
  onDelete?: Function;
  allowedExtensions?: string[];
  notAllowedExtensions?: string[];
  formValidatorErrors: ObjectType;
  name: string;
  title?: string;
  titleSize?: TextType['size'];
  description?: string;
  descriptionSize?: TextType['size'];
  icon?: string | null;
  textHelper?: string;
  multiple?: boolean;
  label?: string;
  statusFiles?: StatusFile[];
  maxCharacterLimit?: number;
  required?: boolean;
  style?: Record<string, CSSProperties>;
}
